<template>
    <div v-if="user">

        <va-page-header>

            <div slot="title">

                <va-button class="back_button" @click.native="$router.go(-1)" type="default" size="lg">
                    <va-icon type="chevron-left"></va-icon>
                </va-button>

                <span v-if="viewedSectionObject == null">{{ _('New ' + sectionCapitalized) }}</span>
                <span v-else>{{ _('Edit ' + sectionCapitalized) }}</span>

                <span class='status' v-if="viewedSectionObject == null">{{ _('Draft') }}</span>
                <span class='status' v-else>{{ _(viewedSectionObject.get('status')) }}</span>

            </div>
            <div slot="actions" style="display: flex; flex-direction: row; align-items:  center">
                <va-checkbox-group v-model="selectedLanguages" style="margin-right: 10px">
                    <va-checkbox label="english" checked>English</va-checkbox>
                    <va-checkbox label="pashto">پښتو</va-checkbox>
                    <va-checkbox label="dari">دری</va-checkbox>
                </va-checkbox-group>
                <va-button
                    v-if="viewedSectionObject && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || (userIsApprover && (user.get('roles').includes(section + '-editor') || user.get('roles').includes(section + '-approver'))) || (user.get('roles').includes(section + '-creator') && viewedSectionObject.get('createdBy') && user && viewedSectionObject.get('createdBy').id == user.id))"
                    size="lg" :class="{no_click: loading}" type="primary" @click.native="saveChanges">
                    {{ _('UPDATE') }}
                </va-button>
                <va-button
                    v-else-if="!viewedSectionObject && (user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes(section + '-editor') || user.get('roles').includes(section + '-creator'))"
                    :class="{no_click: loading}" size="lg" type="primary" @click.native="createObject">
                    <span>{{ _('CREATE') }}</span>
                </va-button>
            </div>

        </va-page-header>

        <va-form ref="form" type="vertical" style="display: block; margin-top: 0px">
            <va-row :gutter="12">
                <va-column :lg="8" :md="8" :sm="12" :xs="12" style="padding-right:30px; margin-top: 20px">

                    <!-- names -->
                    <va-row :gutter="12">
                        <va-column :lg="12" :md="12" :sm="12" :xs="12">
                            <div style="padding-right: 10px">
                                <p class="field_label">{{_(sectionCapitalized + ' Name')}}</p>

                                <va-input v-if="selectedLanguages.includes('english')" style="margin-bottom: 10px"
                                    showClean :disabled="loading" class="largeInput" v-model="nameEnglish"
                                    name="nameEnglish" placeholder="English name" />

                                <va-input v-if="selectedLanguages.includes('pashto')" style="margin-bottom: 10px"
                                    showClean :disabled="loading" class="largeInput" v-model="namePashto"
                                    name="namePashto" placeholder="پښتو نوم" />

                                <va-input v-if="selectedLanguages.includes('dari')" showClean :disabled="loading"
                                    class="largeInput" v-model="nameDari" name="nameDari" placeholder="نام دری" />
                            </div>
                        </va-column>
                    </va-row>

                    <!-- geolocation -->
                    <va-row :gutter="12" style="margin-top: 20px" v-if="section == 'map'">
                        <va-column :lg="12" :md="12" :sm="12" :xs="12">
                            <GmapMap @click="mapClicked" :center="{lat:34.55, lng:69.20}" :zoom="6"
                                map-type-id="terrain" style="max-width: 715px;  height: 500px; padding: 0; margin: 0">
                                <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position"
                                    :clickable="true" :draggable="true" @click="center=m.position"
                                    @dblclick="removeMarker(index)" />
                            </GmapMap>
                            <br>
                            <div style="display: flex">
                                <va-input style="margin-right: 10px" type="number" v-model="lat"
                                    :placeholder="_('Latitude')">
                                </va-input>
                                <va-input style="margin-right: 10px" type="number" :placeholder="_('Longitude')"
                                    v-model="lng">
                                </va-input>
                                <va-button type="primary" @click.native="insertLocation()">{{ _('Insert') }}
                                </va-button>
                            </div>
                        </va-column>
                    </va-row>

                    <!-- descriptions -->
                    <va-row :gutter="12" style="margin-top: 20px" v-if="section != 'article'">
                        <va-column :lg="12" :md="12" :sm="12" :xs="12">
                            <div style="padding-right: 10px">
                                <p class="field_label">{{_('Description')}}</p>
                                <va-tabs :cache-lifetime="10" style="min-height:100px !important;">

                                    <va-tab v-if="selectedLanguages.includes('english')" name="English">
                                        <va-textarea style="width: 100%;  margin-top: 5px" v-model="descriptionEnglish"
                                            :width="'300'" :resize="false" :max-height="'100'" :min-height="'100px'">
                                        </va-textarea>
                                    </va-tab>

                                    <va-tab v-if="selectedLanguages.includes('pashto')" name="پښتو">
                                        <va-textarea style="width: 100%;  margin-top: 5px" v-model="descriptionPashto"
                                            :width="'300'" :resize="false" :max-height="'100'" :min-height="'100px'">
                                        </va-textarea>
                                    </va-tab>

                                    <va-tab v-if="selectedLanguages.includes('dari')" name="دری">
                                        <va-textarea style="width: 100%;  margin-top: 5px" v-model="descriptionDari"
                                            :width="'300'" :resize="false" :max-height="'100'" :min-height="'100px'">
                                        </va-textarea>
                                    </va-tab>

                                </va-tabs>

                            </div>
                        </va-column>
                    </va-row>

                    <va-row :gutter="12" style="margin-top: 20px" v-else>
                        <va-column :lg="12" :md="12" :sm="12" :xs="12">
                            <div style="padding-right: 10px">
                                <p class="field_label">{{_('Description')}}</p>
                                <va-tabs :key="tabsKey" :cache-lifetime="10" style="min-height:680px !important;">

                                    <va-tab v-if="selectedLanguages.includes('english')" name="English">
                                        <vue-editor useCustomImageHandler @imageAdded="handleImageAdded"
                                            :class="{no_click: loading}" class="editor" v-model="descriptionEnglish">
                                        </vue-editor>
                                    </va-tab>

                                    <va-tab v-if="selectedLanguages.includes('pashto')" name="پښتو">
                                        <vue-editor useCustomImageHandler @imageAdded="handleImageAdded"
                                            :class="{no_click: loading}" class="editor" v-model="descriptionPashto">
                                        </vue-editor>
                                    </va-tab>

                                    <va-tab v-if="selectedLanguages.includes('dari')" name="دری">
                                        <vue-editor useCustomImageHandler @imageAdded="handleImageAdded"
                                            :class="{no_click: loading}" class="editor" v-model="descriptionDari">
                                        </vue-editor>
                                    </va-tab>

                                </va-tabs>
                            </div>
                        </va-column>
                    </va-row>

                    <!-- attachements -->
                    <va-row :gutter="12"
                        v-if="!viewedSectionObject || (section == 'file' && !viewedSectionObject) || (viewedSectionObject && section != 'file')">
                        <va-column :lg=12>
                            <div style="padding-right: 10px">
                                <p class="field_label">{{_('Attach File')}}</p>

                                <input v-if="section == 'article'" multiple :disabled="loading"
                                    @change="loadAttachments" type="file" id="attachment" name="attachment"
                                    :rules="[{type:'required'}]" />

                                <input v-else-if="section == 'file'" :disabled="loading" @change="loadAttachments"
                                    type="file" id="attachment" name="attachment" :rules="[{type:'required'}]" />

                                <input v-else-if="section == 'map'" multiple :disabled="loading"
                                    @change="loadAttachments" type="file" id="attachment" name="attachment"
                                    :rules="[{type:'required'}]" accept="application/pdf, image/*" />

                                <div
                                    style="display: flex; flex-direction: row; align-items: flex-end; flex-wrap:wrap; flex:auto;">
                                    <div v-for="(file, index) in selectedAttachments"
                                        style="display: flex; flex-direction: row; margin-right: 8px;">
                                        <div style="display:flex; flex-direction: column">
                                            <div class="file_chip">
                                                <span class="file_text">{{ file.file.name }}</span>
                                                <va-button style="margin-top: -3px;" type="subtle-link"
                                                    @click.native="removeAttachment(index)">
                                                    <va-icon type="times"></va-icon>
                                                </va-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </va-column>
                    </va-row>

                    <!-- approvers -->
                    <va-row :gutter="12">
                        <va-column :lg="12" :md="12" :sm="12" :xs="12" style="margin-top: 10px">
                            <va-card :elevation="2" :padding="10" style="padding: 10px">
                                <user-selection v-bind:selected.sync="selectedApprovers"
                                    v-bind:isAssigningUser.sync="isAssigningApprovers" :showRequired="true"
                                    title='Approvers' :roles="getRoles" :disable="disable" :hasData="hasData"
                                    :department="currentDepartment" />
                            </va-card>
                        </va-column>
                    </va-row>

                    <va-row :gutter="12">
                        <va-column :lg="12" :md="12" :sm="12" :xs="12" style="margin-top: 10px">
                            <va-card :elevation="2" :padding="10" style="padding: 10px">
                                <user-selection v-bind:selected.sync="sharedWith" :showRequired="false"
                                    :title="_('Share With Guests')" :roles="['guest']" :disable="disable"
                                    :hasData="hasData" />
                            </va-card>
                        </va-column>
                    </va-row>

                </va-column>

                <va-column :lg="4" :md="4" :sm="12" :xs="12" class="meta_form">
                    <div class="meta_form_head">

                        <va-select
                            v-if="(viewedSectionObject == null || !viewedSectionObject.get('meta_form_layout')) && getMetaForms"
                            :readonly="loading" @change="showMetaFormLayout" :options="getMetaForms"
                            v-model="selectedFormId" :no-uncheck="false" :placeholder="_('Meta Form')"
                            class="lang-select">
                        </va-select>

                        <span v-else class="meta_form_title">{{ g_getLabel(metaFormLayout) }}</span>

                    </div>

                    <form-submitter ref="formSubmitter" :selectedFormId="selectedFormId" :metaData="viewedMetaData"
                        :hasData="hasData" :viewedMetaFormSelectedLanguage="viewedMetaFormSelectedLanguage" />

                    <div v-if="!selectedFormId">
                        <p style="text-align: center; color: gray; padding: 20px">{{ _('Select a meta form') }}</p>
                    </div>
                </va-column>
            </va-row>
        </va-form>
    </div>
</template>

<script>
    import Parse from "@/main.js"
    import { mapActions, mapGetters } from 'vuex';
    import { VueEditor, Quill } from 'vue2-editor';
    import FormSubmitter from "./FormSubmitter.vue"
    import UserSelection from "./UserSelection.vue"

    export default {
        components: {
            VueEditor,
            UserSelection,
            FormSubmitter
        },
        data() {
            return {
                hasData: false,
                nameEnglish: '',
                namePashto: '',
                nameDari: '',
                selectedType: null,
                descriptionEnglish: '',
                descriptionPashto: '',
                descriptionDari: '',
                selectedFile: null,
                uploadingLoader: false,
                progressText: '',
                parentRoute: '',
                viewedSectionObject: null,
                viewedSectionObjectMime: '',
                viewedSectionObjectSize: 0,
                metaForms: [],
                metaFormsEnglish: [],
                metaFormsPashto: [],
                metaFormsDari: [],
                selectedMetaForm: '',
                targetMetaForm: {},
                theVars: {},
                markers: [],
                metaFormSubmmittedResponseId: '',
                fields: {},
                metaFormTitle: '',
                viewedMetaFormRecord: null,
                attachments: [],
                metaFormLanguages: [],
                selectedLanguages: ['english'],
                shareDetails: null,
                isAssigningApprovers: false,
                approvers: [],
                selectedApprovers: [],
                sharedWith: [],
                approverUsername: '',
                previousApproversCount: 0,
                selectedFormId: null,
                myDataEnglish: {},
                myDataPashto: {},
                myDataDari: {},
                metaFormLayout: { get: () => '' },
                section: '',
                sectionCapitalized: '',
                selectedAttachments: [],
                disable: false,
                tabsKey: '',
                markers: [],
                lat: 0,
                lng: 0,
                viewedMetaFormRecordEnglish: null,
                viewedMetaFormRecordPashto: null,
                viewedMetaFormRecordDari: null,
                viewedMetaFormSelectedLanguage: [],
                category: null,
                currentDepartment: null,
                viewedMetaData: null,
            }
        },
        watch: {
            selectedLanguages: function (val) {
                this.tabsKey = Date.now()
                if (this.selectedLanguages.length == 0) {
                    this.selectedLanguages.push('english')
                }
                if (!this.viewedSectionObject) {
                    if (!this.selectedLanguages.includes('english')) this.nameEnglish = ''
                    if (!this.selectedLanguages.includes('pashto')) this.namePashto = ''
                    else this.nameDari = ''
                }
            }
        },
        computed: {
            ...mapGetters(['user', 'getSystemLanguage', 'loading', 'getCurrentCategory', 'getCurrentDepartment']),

            userIsApprover() {
                var isApprover = false;
                if (this.viewedSectionObject != null && this.viewedSectionObject.get('approvers') != null) {
                    for (let i = 0; i < this.viewedSectionObject.get('approvers').length; i++) {
                        const approver = this.viewedSectionObject.get('approvers')[i];
                        if (approver != null && this.user != null && approver.id == this.user.id) {
                            isApprover = true;
                            break
                        }
                    }
                }
                return isApprover;
            },

            getCategory() {
                return this.category || this.getCurrentCategory
            },

            getMetaForms() {
                if (this.getSystemLanguage == 'dari') return this.metaFormsDari
                else if (this.getSystemLanguage == 'pashto') return this.metaFormsPashto
                else return this.metaFormsEnglish
            },

            getRoles() {
                if (this.user.get('roles').includes('manager') || this.user.get('roles').includes(this.section + '-editor') || this.user.get('roles').includes(this.section + '-creator')) {
                    return ['manager', this.section + '-editor', this.section + '-approver']
                } else if (this.user.get('roles').includes('admin')) {
                    return ['admin', 'manager', this.section + '-editor', this.section + '-approver']
                }
            },


        },
        methods: {

            insertLocation() {

                let lat = parseFloat(this.lat);
                let lng = parseFloat(this.lng);

                this.markers.push({ position: { lat: lat, lng: lng } });
            },

            mapClicked(loc, item) {
                this.markers.push({ position: { lat: loc.latLng.lat(), lng: loc.latLng.lng() } });
            },

            removeMarker(index) {
                this.markers.splice(index, 1)

            },

            handleImageAdded(file, Editor, cursorLocation, resetUploader) {
                this.uploadSelectedImage(file)
                    .then(res => {
                        Editor.insertEmbed(cursorLocation, 'image', res);
                    })
            },

            uploadSelectedImage(file) {
                return new Promise((resolve, reject) => {
                    var name = file.name.slugify(true);
                    var parseFile = new Parse.File(name, file);
                    parseFile.save()
                        .then(function (file) {
                            resolve(file._url)
                        }, function (error) {
                        });
                })
            },

            showMetaFormLayout(metaForm) {
                this.selectedFormId = metaForm
            },

            loadAttachments(e) {
                for (let index = 0; index < e.target.files.length; index++) {
                    this.selectedAttachments.push({
                        file: e.target.files[index],
                        isNew: true
                    })
                }
            },

            removeAttachment(index) {
                this.selectedAttachments.splice(index, 1)
            },

            uploadAttachment() {
                var promises = []
                for (let index = 0; index < this.selectedAttachments.length; index++) {
                    if (this.selectedAttachments[index].isNew) {
                        promises.push(new Promise((resolve, reject) => {
                            var name = this.selectedAttachments[index].file.name.slugify(true);
                            var parseFile = new Parse.File(name, this.selectedAttachments[index].file);
                            parseFile.save()
                                .then(function (file) {
                                    resolve(file._url)
                                }, function (error) {
                                });
                        }))
                    }
                }
                return promises
            },

            validateContent() {
                if ((this.selectedLanguages.includes('english') && this.nameEnglish == '') || (this.selectedLanguages.includes('pashto') && this.namePashto == '') || (this.selectedLanguages.includes('dari') && this.nameDari == '')) {
                    this.$notify({
                        group: 'foo',
                        text: this._('Name is required'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                    this.$store.commit('setLoading', false)
                    return false
                }
                if (this.section == 'map' && this.markers.length == 0 && this.selectedAttachments.length == 0) {
                    this.$notify({
                        group: 'foo',
                        text: this._('Please provide GPS points or attach a file'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                    this.$store.commit('setLoading', false)
                    return false
                }

                if ((this.selectedAttachments.length == 0 && this.section == 'file') && !this.viewedSectionObject) {
                    this.$notify({
                        group: 'foo',
                        text: this._('Attachment is required'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                    this.$store.commit('setLoading', false)
                    return false
                }

                if (this.isAssigningApprovers && this.selectedApprovers.length == 0) {
                    this.$notify({
                        group: 'foo',
                        text: this._('Approver is required'),
                        duration: 4000,
                        position: 'top left',
                        type: 'error'
                    });
                    this.$store.commit('setLoading', false)
                    return false
                }
                return true
            },

            async createObject() {
                this.$store.commit('setLoading', true)
                if (this.validateContent()) {
                    Promise.all(this.uploadAttachment())
                        .then(async attachmentUrl => {

                            let metaFormResult
                            if (this.selectedFormId) metaFormResult = await this.$refs.formSubmitter.submitNewEntry()
                            else {
                                metaFormResult = { metaFormEntryId: '', metaFormLayout: null, submission_language: '' }
                            }

                            var Section = Parse.Object.extend(this.sectionCapitalized);
                            var newObject = new Section();

                            let obj = {
                                label_english: this.nameEnglish,
                                label_pashto: this.namePashto,
                                label_dari: this.nameDari,
                                description_english: this.descriptionEnglish,
                                description_pashto: this.descriptionPashto,
                                description_dari: this.descriptionDari,
                                category: this.getCategory,
                                category_slug: this.getCategory.get('slug'),
                                department: this.currentDepartment,
                                createdBy: this.user,
                                status: this.selectedApprovers.length != 0 ? 'pending' : 'approved',

                                meta_data_id: metaFormResult.metaFormEntryId,
                                meta_form_layout: metaFormResult.metaFormLayout,
                                meta_data_language: metaFormResult.submission_language,

                                languages: this.selectedLanguages,
                                approvers: this.selectedApprovers.map(user => user.user),
                                approvalBy: this.selectedApprovers.length != 0 ? null : this.user,
                                shared_with: this.sharedWith.map(guest => guest.user),
                            }

                            if (this.section == 'file') {
                                obj['mime'] = this.selectedAttachments[0].file.type
                                obj['size'] = this.selectedAttachments[0].file.size
                                obj['attachments'] = attachmentUrl[0]
                            } else if (this.section == 'map') {
                                obj['markers'] = this.markers
                                obj['attachments'] = attachmentUrl
                            } else if (this.section == 'article') {
                                obj['attachments'] = attachmentUrl
                            }

                            newObject.save(obj)
                                .then(createdObject => {

                                    this.g_newActivity({
                                        label_english: this.nameEnglish,
                                        label_pashto: this.namePashto,
                                        label_dari: this.nameDari,
                                        type: this.section,
                                        action: 'create',
                                        url: this.$route.path.slice(0, -8) + createdObject.id,
                                        createdBy: this.user.id,
                                        to: null,
                                        category: this.getCategory,
                                        department: this.currentDepartment,
                                        class: this.sectionCapitalized,
                                        reference_id: createdObject.id
                                    })

                                    if (this.sharedWith != null && createdObject.get('status') == 'approved') {
                                        this.sharedWith.forEach(guest => {
                                            this.g_newActivity({
                                                label_english: this.nameEnglish,
                                                label_pashto: this.namePashto,
                                                label_dari: this.nameDari,
                                                type: this.section,
                                                action: 'shareWithGuest',
                                                url: this.$route.path.slice(0, -8) + createdObject.id,
                                                createdBy: this.user.id,
                                                to: guest.user,
                                                category: this.getCategory,
                                                department: this.currentDepartment,
                                                class: this.sectionCapitalized,
                                                reference_id: createdObject.id
                                            })
                                        })
                                    }
                                    this.selectedApprovers.forEach(approver => {
                                        this.g_newActivity({
                                            label_english: this.nameEnglish,
                                            label_pashto: this.namePashto,
                                            label_dari: this.nameDari,
                                            type: this.section,
                                            action: 'approvalAssignment',
                                            url: this.$route.path.slice(0, -8) + createdObject.id,
                                            createdBy: this.user.id,
                                            to: approver.user,
                                            category: this.getCategory,
                                            department: this.currentDepartment,
                                            class: this.sectionCapitalized,
                                            reference_id: createdObject.id
                                        })
                                    })


                                    this.$store.commit('setLoading', false)
                                    this.$notify({
                                        group: 'foo',
                                        text: this._(this.sectionCapitalized + ' was uploaded'),
                                        duration: 4000,
                                        position: 'top left',
                                        type: 'success'
                                    });
                                    this.$router.go(-1)

                                }).catch(error => {
                                    this.$store.commit('setLoading', false)
                                    this.$notify({
                                        group: 'foo',
                                        title: this._('System Error'),
                                        text: this._('An error was encountered while creating ' + this.section),
                                        duration: 4000,
                                        position: 'top left',
                                        type: 'error'
                                    });
                                });
                        })
                        .catch(error => {
                            this.$store.commit('setLoading', false)
                        })
                }
            },

            async saveChanges() {
                this.$store.commit('setLoading', true)
                if (this.validateContent()) {

                    Promise.all(this.uploadAttachment())
                        .then(async attachmentsUrls => {
                            this.selectedAttachments.forEach(att => {
                                if (!att.isNew) attachmentsUrls.push(att.url)
                            })
                            if (this.viewedSectionObject.get('label_english') != this.nameEnglish || this.viewedSectionObject.get('label_pashto') != this.namePashto || this.viewedSectionObject.get('label_dari') != this.nameDari || this.viewedSectionObject.get('description_english') != this.descriptionEnglish || this.viewedSectionObject.get('description_pashto') != this.descriptionPashto || this.viewedSectionObject.get('description_dari') != this.descriptionDari) {
                                this.g_newActivity({
                                    label_english: this.nameEnglish,
                                    label_pashto: this.namePashto,
                                    label_dari: this.nameDari,
                                    type: this.section,
                                    action: 'edit',
                                    url: this.$route.path.slice(0, -15) + this.viewedSectionObject.id,
                                    createdBy: this.user.id,
                                    to: null,
                                    category: this.getCategory,
                                    department: this.currentDepartment,
                                    class: this.sectionCapitalized,
                                    reference_id: this.viewedSectionObject.id
                                })
                            }

                            let metaFormResult

                            if (this.selectedFormId) {
                                if (!this.viewedSectionObject.get('meta_form_layout')) metaFormResult = await this.$refs.formSubmitter.submitNewEntry()
                                else {
                                    metaFormResult = await this.$refs.formSubmitter.updateSubmission()
                                }
                            }
                            else {
                                metaFormResult = { metaFormEntryId: '', metaFormLayout: null, submission_language: '' }
                            }

                            this.viewedSectionObject.set('label_english', this.selectedLanguages.includes('english') ? this.nameEnglish : '')
                            this.viewedSectionObject.set('label_pashto', this.selectedLanguages.includes('pashto') ? this.namePashto : '')
                            this.viewedSectionObject.set('label_dari', this.selectedLanguages.includes('dari') ? this.nameDari : '')
                            this.viewedSectionObject.set('description_english', this.selectedLanguages.includes('english') ? this.descriptionEnglish : '')
                            this.viewedSectionObject.set('description_pashto', this.selectedLanguages.includes('pashto') ? this.descriptionPashto : '')
                            this.viewedSectionObject.set('description_dari', this.selectedLanguages.includes('dari') ? this.descriptionDari : '')
                            this.viewedSectionObject.set('languages', this.selectedLanguages)
                            if (this.section != 'file') this.viewedSectionObject.set('attachments', attachmentsUrls)
                            this.viewedSectionObject.set('approvers', this.selectedApprovers.map(user => user.user))
                            this.viewedSectionObject.set('status', this.selectedApprovers != null ? this.selectedApprovers.length == 0 ? 'approved' : 'pending' : 'approved')
                            this.viewedSectionObject.set('shared_with', this.sharedWith.map(guest => guest.user))

                            if (this.selectedFormId) {
                                if (!this.viewedSectionObject.get('meta_form_layout')) {
                                    // this if is for objects without any meta form attached, but we now select one
                                    this.viewedSectionObject.set('meta_form_layout', metaFormResult.metaFormLayout)
                                    this.viewedSectionObject.set('meta_data_id', metaFormResult.metaFormEntryId)
                                    this.viewedSectionObject.set('meta_data_language', metaFormResult.submission_language)
                                } else {
                                    // for updating meta form we are not doing anything, the object it self will be updated

                                }
                            }
                            if (this.section == 'map') this.viewedSectionObject.set('markers', this.markers)

                            if (this.previousApproversCount < this.selectedApprovers.length) {
                                this.g_newActivity({
                                    label_english: this.nameEnglish,
                                    label_pashto: this.namePashto,
                                    label_dari: this.nameDari,
                                    type: this.section,
                                    action: 'approverAdd',
                                    url: this.$route.path.slice(0, -15) + this.viewedSectionObject.id,
                                    createdBy: this.user.id,
                                    to: null,
                                    category: this.getCategory,
                                    department: this.currentDepartment,
                                    class: this.sectionCapitalized,
                                    reference_id: this.viewedSectionObject.id
                                })
                            }

                            if (this.previousApproversCount > this.selectedApprovers.length) {
                                this.g_newActivity({
                                    label_english: this.nameEnglish,
                                    label_pashto: this.namePashto,
                                    label_dari: this.nameDari,
                                    type: this.section,
                                    action: 'approverRemove',
                                    url: this.$route.path.slice(0, -15) + this.viewedSectionObject.id,
                                    createdBy: this.user.id,
                                    to: null,
                                    category: this.getCategory,
                                    department: this.currentDepartment,
                                    class: this.sectionCapitalized,
                                    reference_id: this.viewedSectionObject.id
                                })
                            }

                            this.viewedSectionObject
                                .save()
                                .then(updated => {
                                    if (this.selectedApprovers != null) {
                                        this.selectedApprovers.forEach(approver => {
                                            if (!approver.isPrev) {
                                                this.g_newActivity({
                                                    label_english: this.nameEnglish,
                                                    label_pashto: this.namePashto,
                                                    label_dari: this.nameDari,
                                                    type: this.section,
                                                    action: 'approvalAssignment',
                                                    url: this.$route.path.slice(0, -15) + this.viewedSectionObject.id,
                                                    createdBy: this.user.id,
                                                    to: approver.user,
                                                    category: this.getCategory,
                                                    department: this.currentDepartment,
                                                    class: this.sectionCapitalized,
                                                    reference_id: this.viewedSectionObject.id

                                                })
                                            }
                                        })
                                    }

                                    this.$store.commit('setLoading', false)
                                    this.viewedSectionObject = updated
                                    this.$notify({
                                        group: 'foo',
                                        text: this._(this.sectionCapitalized + ' was updated'),
                                        duration: 4000,
                                        position: 'top left',
                                        type: 'success'
                                    });
                                })
                                .catch(error => {
                                    this.$store.commit('setLoading', false)
                                    this.$notify({
                                        group: 'foo',
                                        title: this._('Error'),
                                        text: this._(
                                            'An error was encountered while updating ' + this.section
                                        ),
                                        duration: 4000,
                                        position: 'top left',
                                        type: 'error'
                                    });
                                })
                        }).catch(e => {

                        })
                }
            },

            navigate(route) {
                this.$router.push(route)
            },


            async fetchMetaForms() {
                let q = new Parse.Query('Form')
                q.equalTo('type', this.section)
                q.equalTo('category', this.getCategory)
                q.equalTo('department', this.currentDepartment)
                q.equalTo('is_enabled', true)
                q.descending('createdAt')
                let result = await q.find()
                this.metaFormsEnglish = result.map(l => {
                    return {
                        label: l.get('label_english'),
                        value: l.id
                    }
                })
                this.metaFormsPashto = result.map(l => {
                    return {
                        label: l.get('label_pashto') == '' ? l.get('label_english') : l.get('label_pashto'),
                        value: l.id
                    }
                })
                this.metaFormsDari = result.map(l => {
                    return {
                        label: l.get('label_dari') == '' ? l.get('label_english') : l.get('label_dari'),
                        value: l.id
                    }
                })
            },

            async fetchMetaFormData() {
                let metaFormLayout = await this.viewedSectionObject.get('meta_form_layout').fetch()
                this.metaFormLayout = metaFormLayout
                this.showMetaFormLayout(metaFormLayout.id)

                if (metaFormLayout && metaFormLayout.get('class_name')) {
                    let q = new Parse.Query(metaFormLayout.get('class_name'))
                    q.equalTo('objectId', this.viewedSectionObject.get('meta_data_id'))
                    var meta_date = await q.first()
                    this.viewedMetaData = meta_date
                    // this.showMetaFormLayout(metaFormLayout.id)
                }
            },

            async fetchings() {
                this.$store.commit("setLoading", true);
                this.section = this.$route.matched[0].name.substring(0, this.$route.matched[0].name.length - 1)
                this.sectionCapitalized = this.section.charAt(0).toUpperCase() + this.section.slice(1)
                this.category = this.getCurrentCategory
                this.currentDepartment = this.getCurrentDepartment
                await this.fetchMetaForms()

                if (this.$route.params.id && this.$route.params.id != 'new') {
                    this.viewedSectionObject = await this.g_fetchObject(this.$route.params.id, this.sectionCapitalized)
                    if (this.section == 'map') this.markers = this.viewedSectionObject.get('markers')
                    this.selectedLanguages = this.viewedSectionObject.get('languages')
                    this.nameEnglish = this.viewedSectionObject.get('label_english')
                    this.namePashto = this.viewedSectionObject.get('label_pashto')
                    this.nameDari = this.viewedSectionObject.get('label_dari')
                    this.descriptionEnglish = this.viewedSectionObject.get('description_english')
                    this.descriptionPashto = this.viewedSectionObject.get('description_pashto')
                    this.descriptionDari = this.viewedSectionObject.get('description_dari')

                    this.isAssigningApprovers = this.viewedSectionObject.get('status') == 'pending'
                    this.disable = this.viewedSectionObject.get('status') != 'pending'

                    this.previousApproversCount = this.viewedSectionObject.get('approvers').length

                    for (const key in this.viewedSectionObject.get('approvers')) {
                        await this.viewedSectionObject.get('approvers')[key].fetch()
                    }

                    this.selectedApprovers = this.viewedSectionObject.get('approvers').map(user => {
                        return { user: user, isPrev: true, hasSubmission: false }
                    })

                    this.sharedWith = this.viewedSectionObject.get('shared_with').map(guest => {
                        return { user: guest, isPrev: true, hasSubmission: false }
                    })

                    if (this.viewedSectionObject && this.viewedSectionObject.get('meta_form_layout') && this.viewedSectionObject.get('meta_data_id')) {
                        this.hasData = true
                        await this.fetchMetaFormData()
                    } else {
                        this.hasData = false
                    }

                    if (this.viewedSectionObject.get('attachments').length != 0 && (this.section == 'article' || this.section == 'map')) {
                        this.selectedAttachments = this.viewedSectionObject.get('attachments').map(att => {
                            return {
                                file: { name: att.split('/')[att.split('/').length - 1] },
                                url: att,
                                isNew: false
                            }
                        })
                    }
                }
                this.$store.commit("setLoading", false);
            }

        },

        async mounted() {
            await this.fetchings()
        }
    }
</script>

<style>
    .meta_form {
        border: 1px solid #dadada55;
        background: #dbdcdf22;
        margin-top: 40px;
    }

    .meta_form_head {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #dadada;
    }

    .largeInput,
    .largeInput input {
        width: 100% !important;
    }

    @media only screen and (min-width: 30rem) {
        .va-col-sm-10 {
            max-width: 100% !important;
        }
    }

    .editor {
        margin-top: 5px;
        min-height: 450px !important;
    }

    .editor .ql-container {
        min-height: 450px !important;
    }

    .editor .ql-editor {
        min-height: 450px !important;
        margin-right: -10px;
    }

    .meta_form_title {
        font-size: 18px;
        color: #666;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
        text-align: center
    }
</style>